import React from "react";
import Header from "./components/Header";
import { Footer } from "./components/Footer";
import { Pmwani } from "./components/Pmwani";

export const PmwaniPlans = ({ match }) => {
  const slugData = match?.params?.slug || "";

  return (
    <>
      <Header />

      {/* Optional banner (same as broadband) */}
      <section id="banner" className="p-0">
        <div className="banner booknow filter m-0 h-120"></div>
      </section>

      <section id="pmwani" className="blckarrow">
        <div className="container">
          <div className="row">
            <div
              className="title"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="600"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <span>PDO Tariff Plan</span>
              <h3>PM-WANI Free Public Wi-Fi Plan</h3>
            </div>

            {/* ✅ Clean wrapper (no slider, same UI spacing) */}
            <div className="planslider pmwani-wrapper">
              <div className="pmwani-card-container">
                <Pmwani slugData={slugData} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
